@if (pending()) {
  <icon class="forma-button__loading-icon" name="arrows-clockwise" size="small" />
}

<span class="forma-button__icon-slot" [class.forma-button__icon-slot--hidden]="pending()">
  <ng-content select="icon"></ng-content>
</span>

<span class="forma-button_label">
  @if (pending() && pendingText()) {
    {{ pendingText() }}
  } @else {
    <ng-content></ng-content>
  }
</span>

